import {all, fork} from 'redux-saga/effects';

import apiSaga from './ApiSaga';
import getRouteData from './RouteSaga';
import localStorageSaga from './LocalStorageSaga';
import downloadSaga from './DownloadSaga';

/**
 * This is the root saga. It will be started by the saga middleware.
 * It will then start all other sagas.
 *
 * @param args
 */
export default function* rootSaga(...args) {
    yield all([
        fork(apiSaga),
        fork(getRouteData, ...args),
        fork(localStorageSaga),
        fork(downloadSaga)
    ]);
}